import { RCCAlert, RCCButton, RCCGrid,  RCCTooltip } from "react-common-components";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import React, {useEffect} from "react";
import { ILinkOccurence, ITabLinks } from "../../../../interface";
import LinkItem from "./linkItem";


const TabLinks : React.FC<ITabLinks> = ({
	control,
	register,
	error,
	disabled,
	occurrenceLinks
}) => {

	const { translate } = useTranslation();

	const { 
		fields,
		remove,
		append
	} = useFieldArray({
		control,
		shouldUnregister: true,
		name: "octbb005"
	});

	useEffect(() => {
		if(occurrenceLinks)
			append(occurrenceLinks);
	}, []);

	return (
		<>
			<RCCGrid
				container
				item
				direction="column"
				alignItems="center"
			>
				<RCCGrid
					container
					item		
				>
					<RCCGrid
						item
						container
						justifyContent="flex-end"
					>
						{!disabled && (
							<>
								<RCCTooltip
									text={translate("Associar Link")}
									color="purple"
								>	
									<RCCButton
										icon={{name: "plus"}}
										color="purple"
										onClick={() => {
											append({} as ILinkOccurence);
										}}
										size="md"
										layout="isRounded"
									/>
								</RCCTooltip>
							</>
						)}
					</RCCGrid>

					<RCCGrid
						container
						item
					>
						{fields.length <= 0 ? (
							<>
								<RCCAlert 
									title={translate("Atenção")}	
									description={translate("Esta ocorrência não possui nenhum link associado")}
								/>
							</>
						) : (
							<>
								{/* Informações */}
								<RCCGrid
									container
									item
								>
									<RCCGrid 
										item
										container	
										xs={12}			
										style={{marginTop: "10px"}}
									>
										{fields && fields.map((item: any, index: number) => (
											<RCCGrid
												container
												item
												xs={12}
												key={v4()}
												alignItems="baseline"
											>
												<LinkItem 
													id={item.ocb005Id || 0}
													control={control}
													index={index}
													link={item.ocb005LinkExterno || ""}
													register={register}
													remove={remove}
													disabled={disabled}
													error={error}
												/>
											</RCCGrid>
										))}
										
									</RCCGrid>
								</RCCGrid>
							</>
						)}
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
		</>
	);

};



export default TabLinks;
